/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientFieldDefinitions = sqliteTable('patient_field_definitions', {
  id: text('id').primaryKey().notNull(),
  key: text('key'),
  field_type: text('field_type'),
  category: text('category'),
  default_label: text('default_label'),
  default_enabled: integer('default_enabled'),
  required_override: integer('required_override'),
  order_override: integer('order_override'),
  width_override: text('width_override'),
  validation_override: text('validation_override'),
  updated_at: text('updated_at'),
});
